/* Albemore expert endorsements
   Cross-fades a set of portraits and quotes, driven by thumbnail buttons, with an
   optional auto-advance that pauses on hover, focus, or when the tab is hidden.
   Vanilla, no dependencies, multi-instance safe. Reference behaviour was Alpine;
   this is the same effect without the framework. If this script never runs, the
   section CSS falls back to showing the first portrait and first quote. */
(function () {
  'use strict';

  var prefersReduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  function Experts(root) {
    this.root = root;
    this.portraits = Array.prototype.slice.call(root.querySelectorAll('[data-ec-portrait]'));
    this.quotes = Array.prototype.slice.call(root.querySelectorAll('[data-ec-quote]'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ec-thumb]'));
    this.total = this.portraits.length;
    this.active = 0;
    this.timer = null;
    this.interval = parseInt(root.getAttribute('data-ec-interval'), 10) || 8000;
    if (this.interval < 3000) this.interval = 3000;
    this.autoplay = root.getAttribute('data-ec-autoplay') === 'true' && this.total > 1 && !prefersReduced();
    this.init();
  }

  Experts.prototype.init = function () {
    if (!this.total) return;
    var self = this;

    this.thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        self.select(i);
        self.restart();
      });
    });

    // Pause while the visitor is interacting, resume when they leave.
    ['mouseenter', 'focusin'].forEach(function (evt) {
      self.root.addEventListener(evt, function () { self.stop(); });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      self.root.addEventListener(evt, function () { self.start(); });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { self.stop(); } else { self.start(); }
    });

    // ec-ready hands opacity control from the CSS fallback to the is-active classes.
    this.root.classList.add('ec-ready');
    this.select(0);
    this.start();
  };

  Experts.prototype.select = function (i) {
    if (i < 0 || i >= this.total) return;
    this.active = i;
    for (var n = 0; n < this.total; n++) {
      var on = n === i;
      if (this.portraits[n]) this.portraits[n].classList.toggle('is-active', on);
      if (this.quotes[n]) this.quotes[n].classList.toggle('is-active', on);
      if (this.thumbs[n]) {
        this.thumbs[n].classList.toggle('is-active', on);
        this.thumbs[n].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }
  };

  Experts.prototype.next = function () {
    if (this.total > 0) this.select((this.active + 1) % this.total);
  };

  Experts.prototype.start = function () {
    if (!this.autoplay || this.timer) return;
    var self = this;
    this.timer = window.setInterval(function () { self.next(); }, this.interval);
  };

  Experts.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  Experts.prototype.restart = function () {
    this.stop();
    this.start();
  };

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-ec]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__ecReady) return;
      root.__ecReady = true;
      new Experts(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-init when merchandisers add or move the section in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
